// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Shared from "./Shared.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function LandingPage(props) {
  return JsxRuntime.jsx(Shared.make, {
              children: props.children
            });
}

var make = LandingPage;

export {
  make ,
}
/* Shared Not a pure module */
